'use strict';

var localStorageUtils = {
    // Set an item in localStorage
    setItem(key, value) {
        try {
            const stringValue = JSON.stringify(value);
            localStorage.setItem(key, stringValue);
        } catch (error) {
            console.error('Error saving to localStorage', error);
        }
    },

    // Get an item from localStorage
    getItem(key) {
        try {
            const value = localStorage.getItem(key);
            return value ? JSON.parse(value) : null;
        } catch (error) {
            console.error('Error reading from localStorage', error);
            return null;
        }
    },

    // Remove an item from localStorage
    removeItem(key) {
        try {
            localStorage.removeItem(key);
        } catch (error) {
            console.error('Error removing from localStorage', error);
        }
    },

    // Clear all items from localStorage
    clear() {
        try {
            localStorage.clear();
        } catch (error) {
            console.error('Error clearing localStorage', error);
        }
    }
};

module.exports = localStorageUtils;
